// Lector unico del token de sesion.
// La app guarda el JWT en localStorage como 'lexduo_token' (ver contexts/AuthContext.jsx).
// Durante un tiempo convivio con las claves antiguas 'token' y 'access_token', por lo que
// se aceptan como respaldo para no echar fuera a quien tenga una sesion vieja abierta.
export const obtenerToken = () =>
  localStorage.getItem('lexduo_token') ||
  localStorage.getItem('token') ||
  localStorage.getItem('access_token') ||
  '';

export const cabeceraAuth = () => {
  const token = obtenerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Descarga un fichero de un endpoint protegido.
// window.open y <a href> NO llevan la cabecera Authorization: contra /api siempre dan 401.
export const descargarFichero = async (url, nombrePorDefecto) => {
  try {
    const respuesta = await fetch(url, { headers: cabeceraAuth() });
    if (!respuesta.ok) {
      throw new Error(`HTTP ${respuesta.status}`);
    }
    const disposicion = respuesta.headers.get('Content-Disposition') || '';
    const encontrado = disposicion.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    const nombre = encontrado ? decodeURIComponent(encontrado[1]) : nombrePorDefecto;
    const blob = await respuesta.blob();
    const enlace = document.createElement('a');
    enlace.href = window.URL.createObjectURL(blob);
    enlace.download = nombre;
    document.body.appendChild(enlace);
    enlace.click();
    enlace.remove();
    setTimeout(() => window.URL.revokeObjectURL(enlace.href), 2000);
    return true;
  } catch (error) {
    window.alert(
      'No se pudo descargar el archivo.\n\n' +
      'Si el problema persiste, vuelve a iniciar sesion: puede que tu sesion haya caducado.'
    );
    return false;
  }
};
